export class UsersController {
	constructor($scope, JFrogGridFactory, UsersDao, JFrogModal, commonGridColumns, BruteForceDao, $timeout,
	            JFrogNotifications, XRayUIPermissions, $state) {
        this.BruteForceDao = BruteForceDao;
        this.$scope = $scope;
        this.jfrogGridFactory = JFrogGridFactory;
        this.JFrogNotifications = JFrogNotifications;
        this.$timeout = $timeout;
        this.usersDao = UsersDao;
        this.modal = JFrogModal;
        this.commonGridColumns = commonGridColumns;
		this.$state = $state;
        $scope.$parent.Settings.showButtons = false;
        $scope.$parent.Settings.currentSubController = this;
		this.XRayUIPermissions = XRayUIPermissions;
        this._createGrid();
        this._getUsers();

		if (this.XRayUIPermissions.isAccess()) {
			this.$state.go('home');
		}
    }

    _createGrid() {
        this.gridOptions = this.jfrogGridFactory.getGridInstance(this.$scope)
            .setRowTemplate('default')
            .setColumns(this._getColumns())
            .setButtons(this._getActions())
    }

    _getUsers() {
        this.usersDao.getAll().$promise.then((users) => {
            this.gridOptions.setGridData(users);


            this.$timeout(() => {
                $('a.icon').hover(function () {
                    $(this).addClass('icon-unlock').removeClass('icon-lock')
                }, function () {
                    $(this).removeClass('icon-unlock').addClass('icon-lock');
                });
            })
        })
    }

    deleteUser(row) {
        this.modal.confirm(`Are you sure you want to delete user "${row.name}"?`)
            .then(() => {
                this.usersDao.delete({username: row.name}).$promise.then(()=> {
                    this._getUsers();
                })
            });
    }

    unlockUser(userId) {
        this.BruteForceDao.unlockUser({}, {'userID': userId}).$promise.then((data) => {
            this._getUsers();
            let msg = userId + ' has been successfully unlocked'
            this.JFrogNotifications.create({info: msg}, true);
        });
    }

    _getColumns() {
        return [
            {
                name: 'User Name',
                displayName: 'User Name',
                field: "name",
                cellTemplate: '<div class="ui-grid-cell-contents" ui-sref="settings.users.edit({userName: row.entity.name})"><a href="">{{row.entity.name}}</a></div>',
                width: '40%'
            },
            {
                name: 'Email',
                displayName: 'Email',
                field: "email",
                width: '50%'
            },
            {
                name: 'Locked',
                displayName: 'Locked',
                field: "admin",
                cellTemplate: '<div ng-if="row.entity.blocked" class="ui-grid-cell-contents unlock-user"><a ng-click="grid.appScope.Users.unlockUser(row.entity.name);" jf-tooltip="Unlock" class="icon-lock grid-column-button icon"></a></div>',
                width: '10%'
            }
        ]
    }

    _getActions() {
        return [
            {
                icon: 'icon icon-clear',
                tooltip: 'Delete',
                callback: (row) => this.deleteUser(row)
            }

        ];
    }

}


// WEBPACK FOOTER //
// ./modules/xray/states/settings/tabs/users/users.controller.js